import {MessageDescriptor} from '@lingui/core';
import {t} from '@lingui/macro';

/*
 * Types.
 */

export enum RuleDataTableErrors {
  NO_ROWS = 'DATA_TABLE/NO_ROWS',
  UNUSED = 'DATA_TABLE/UNUSED',
  TOO_MANY_COLUMN = 'DATA_TABLE/TOO_MANY_COLUMNS',
  TOO_MANY_ROWS = 'DATA_TABLE/TOO_MANY_ROWS',
  EMPTY_CELLS = 'DATA_TABLE/EMPTY_CELLS',
}

/*
 * Constants.
 */

export const RULE_DATA_TABLE_MAX_COLUMN_COUNT = 25;
export const RULE_DATA_TABLE_MAX_ROW_COUNT = 500;

export const ruleDataTableErrorLabels: Record<RuleDataTableErrors, MessageDescriptor> = {
  [RuleDataTableErrors.NO_ROWS]: t('rule-editor-data-table-errors-no-rows')`Rule table has no rows`,
  [RuleDataTableErrors.UNUSED]: t(
    'rule-editor-data-table-errors-unused',
  )`Rule table is unused in rule structure`,
  [RuleDataTableErrors.TOO_MANY_COLUMN]: t(
    'rule-editor-data-table-errors-too-many-columns',
  )`Rule table has too many columns`,
  [RuleDataTableErrors.TOO_MANY_ROWS]: t(
    'rule-editor-data-table-errors-too-many-rows',
  )`Rule table has too many rows`,
  [RuleDataTableErrors.EMPTY_CELLS]: t(
    'rule-editor-data-table-errors-empty-cells',
  )`Rule table has empty cells`,
};
